<div class="download">
    <!-- <img class="imageclass" src="assets/images/popup.png">
    <p class="pclass">Please provide the following information to let SpiceTrail help you with your menu</p>
    <mat-form-field class="field">
        <mat-label>Name</mat-label>
        <input matInput type="text" [(ngModel)]="name">
        @if (name) {
        <button matSuffix mat-icon-button (click)="name=''">
            <mat-icon>close</mat-icon>
        </button>
        }
    </mat-form-field>

    <mat-form-field class="field">
        <mat-label>Location</mat-label>
        <input matInput type="text" [(ngModel)]="location">
        @if (location) {
        <button matSuffix mat-icon-button (click)="location=''">
            <mat-icon>close</mat-icon>
        </button>
        }
    </mat-form-field>
    <mat-form-field class="field">
        <mat-label>Tentative date</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="date">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
      <mat-form-field class="field">
        <mat-label>PAX</mat-label>
        <input matInput type="text" [(ngModel)]="pax">
        @if (pax) {
        <button matSuffix mat-icon-button (click)="pax=''">
            <mat-icon>close</mat-icon>
        </button>
        }
    </mat-form-field>

    <mat-form-field class="fieldphone">
        <mat-label>Phone</mat-label>
        <input matInput type="text" [(ngModel)]="phone">
        @if (phone) {
        <button matSuffix mat-icon-button (click)="phone=''">
            <mat-icon>close</mat-icon>
        </button>
        }
    </mat-form-field>
    <button class="btn-icon" (click)="sendOTP()">
        <mat-icon>send</mat-icon>
    </button>
    <mat-form-field class="field">
        <mat-label>OTP</mat-label>
        <input matInput type="text" [(ngModel)]="otp">
        @if (otp) {
        <button matSuffix mat-icon-button (click)="otp=''">
            <mat-icon>close</mat-icon>
        </button>
        }
    </mat-form-field>
    <button class="btn-icon" (click)="startdownload()">
        <mat-icon class="btn-icon">check</mat-icon>
    </button> -->
<img class="imageclass" src="assets/images/popup.png">
    <p class="pclass">Please provide the following information to let SpiceTrail help you with your menu</p>
 <mat-form-field class="fieldcss">
            <mat-label class="fieldtext">Your Name</mat-label>
            <input matInput type="text" [(ngModel)]="name" #nameInput="ngModel" required>
            @if (name) {
            <button matSuffix mat-icon-button (click)="name=''" class="fieldsuffix">
                <mat-icon>close</mat-icon>
            </button>
            }
            <mat-error *ngIf="nameInput.invalid && nameInput.touched">
                Name is required.
            </mat-error>
        </mat-form-field>
               <mat-form-field class="fieldcss">
            <mat-label class="fieldtext">Tentative number of guests</mat-label>
            <input matInput type="number" [(ngModel)]="pax" #paxInput="ngModel" required>
            @if (pax) {
            <button matSuffix mat-icon-button (click)="pax=''" class="fieldsuffix">
                <mat-icon>close</mat-icon>
            </button>
            }
            <mat-error *ngIf="paxInput.invalid && paxInput.touched">
                Number of heads is required.
            </mat-error>
        </mat-form-field>
        <mat-form-field class="fieldcss">
            <mat-label class="fieldtext">Venue if decided or Location</mat-label>
            <input matInput type="text" [(ngModel)]="location"  #locationInput="ngModel" required>
            @if (location) {
            <button matSuffix mat-icon-button (click)="location=''" class="fieldsuffix">
                <mat-icon>close</mat-icon>
            </button>
            }
            <mat-error *ngIf="locationInput.invalid && locationInput.touched">
                Location is required.
            </mat-error>
        </mat-form-field>
        <mat-form-field class="fieldcss">
            <mat-label class="fieldtext">Tentative date of the event</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="date" name="date" #dateInput="ngModel" required>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="dateInput.invalid && dateInput.touched">
                Please select a date.
            </mat-error>
        </mat-form-field>
    <div class="channel-selection-toggle">
        <span class="channel-label" [class.active]=" channel === 'SMS'">SMS</span>
        <mat-slide-toggle color="primary" [(ngModel)]="isWhatsapp" (change)="channel = isWhatsapp ? 'WHATSAPP' : 'SMS'" name="channelToggle">
            
        </mat-slide-toggle>
        <span class="channel-label" [class.active]=" channel === 'Whatsapp'">Whatsapp</span>
    </div>
        <mat-form-field class="mobfieldphone">
            <mat-label class="fieldtext">Enter your Phone No to get OTP</mat-label>
            <input matInput type="number" [(ngModel)]="phone">
            @if (phone) {
            <button matSuffix mat-icon-button (click)="phone=''" class="fieldsuffix">
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>
        <button class="btn-icon" (click)="sendOTP()" class="fieldbutton">
            <mat-icon>textsms</mat-icon>
        </button>
        <mat-form-field class="mobfieldphone" >
            <mat-label class="fieldtext">Enter OTP here and download your menu</mat-label>
            <input matInput type="number" [(ngModel)]="otp">
            @if (otp) {
            <button matSuffix mat-icon-button (click)="otp=''" class="fieldsuffix" >
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>
        <button class="btn-icon" (click)="startdownload()" class="fieldbutton" [disabled]="!verificationID">
            <mat-icon>picture_as_pdf</mat-icon>
       
        </button>

</div>